import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Button, Divider } from 'antd'
import './ListOutsourcingStyle.css'
import { getUser } from '../../../reducers'
import { useState } from 'react';
import { message } from 'antd';
import { firestore } from '../../../config/Fire';
import * as Constants from '../../../constants'
import OutsourcingTable from '../../containers/OutsourcingTable';

function compareByBumeration (a, b) {
    if (a.numeration < b.numeration) {
        return -1;
    } else if (a.numeration > b.numeration) {
        return 1;
    } else {
        return 0;
    }
}

const ListOutsourcing = props => {
    const { outsourcing } = props
    const [loadingOutsourcing, setLoadingOutsourcing] = useState(false)

    const showOutsourcing = id => {
        props.onShowOutsourcing(id)
    }

    const removeOutsourcing = record => {
        if (record) {
            setLoadingOutsourcing(true)
            firestore.collection(Constants.MAIN_NODES.OUTSOURCING_ORDERS).doc(record.id).delete()
                .then(() => {
                    setLoadingOutsourcing(false)
                    message.success('El proveedor se borro exitósamente')
                    props.onOutsourcingDeleted(record.id)
                })
                .catch(err => {
                    setLoadingOutsourcing(false)
                    console.log(err)
                    message.error('Se produjo un error al eliminar el proveedor. Por favor, vuelva a intentarlo')
                })
        }
    }

    return (
        <Grid className="listOutsourcingCont">
            <Row center="xs">
                <Col xs={12}>
                    <h2>Proveedores</h2>
                </Col>
            </Row>
            <Divider/>
            <Button className="newBidOrderButton" onClick={props.onNewSelected} type="primary" size="large">Nuevo Proveedor</Button> 
            <Row center="xs">
                <Col xs={12}>
                    <OutsourcingTable data={(outsourcing && outsourcing !== null) ? Object.values(outsourcing).sort(compareByBumeration) : []}
                        onShowOutsourcing={showOutsourcing}
                        onRemoveOutsourcing={removeOutsourcing} loading={loadingOutsourcing}
                    />
                </Col>
            </Row>
        </Grid>
    )
}

ListOutsourcing.propTypes = {
}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default ListOutsourcing;